import styled from '@emotion/styled';

export const StyledProductLink = styled.a`
  flex: 1 1 auto;
  width: 50%;
  padding: ${({ theme }): number => theme.sizes[6]}px;
  text-align: center;
  color: ${({ theme }): string => theme.colors.blue60};
  font-family: ${({ theme }): string => theme.fonts.regular};
  font-size: ${({ theme }): string => theme.fontSizes[4]};
`;

export const StyledListContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  margin: ${({ theme }): number => theme.space[8]}px auto 0;
`;
